var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M0.555732 10.9082C0.413278 10.7594 0.333252 10.5575 0.333252 10.3471C0.333252 10.1366 0.413278 9.93473 0.555732 9.78588L4.31709 5.85686L0.555732 1.92784C0.417315 1.77814 0.340724 1.57764 0.342455 1.36952C0.344187 1.16141 0.424102 0.962325 0.564988 0.815159C0.705874 0.667993 0.896459 0.584517 1.09569 0.582708C1.29493 0.5809 1.48688 0.660904 1.63019 0.805491L5.92878 5.29568C6.07123 5.44453 6.15126 5.64639 6.15126 5.85686C6.15126 6.06733 6.07123 6.26919 5.92878 6.41803L1.63019 10.9082C1.48769 11.057 1.29445 11.1406 1.09296 11.1406C0.89147 11.1406 0.698229 11.057 0.555732 10.9082Z",
    fill: "#828181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.3f6840362d91305d1eb5832294ba2fbf.svg";
export { ForwardRef as ReactComponent };